module.exports = __webpack_public_path__ + "img/stet.6bea729b.png";